import React from "react";
import { Outlet } from "react-router-dom";
import { useConfiguration } from "contexts/ConfigurationProvider/ConfigurationProvider";
import type { FeatureFlag } from "contexts/ConfigurationProvider/FeatureFlag";
import { LoadablePage } from "shared/LoadablePage";
import { NotFoundPage } from "pages/NotFoundPage";

type FeatureFlaggedRouteProps = {
  featureFlag: FeatureFlag;
  element?: React.ReactNode;
};

export function FeatureFlaggedRoute({ featureFlag, element }: FeatureFlaggedRouteProps) {
  const { isFeatureFlagEnabled, loadedFeatureFlags } = useConfiguration();

  // Flags load asynchronously and default to disabled; wait for them so a direct
  // navigation doesn't flash Not Found before the real value is known.
  if (!loadedFeatureFlags) {
    return <LoadablePage loading />;
  }

  return isFeatureFlagEnabled(featureFlag) ? <>{element || <Outlet />}</> : <NotFoundPage />;
}
